import React, {useMemo, useState} from "react";
import clsx from "clsx";
import Pagination from "../../helpers/Pagination";
import Alert from "../../helpers/Alert";
import ProductListHeader from "./ProductListHeader";
import ProductListFilter from "./ProductListFilter";

function Product({id, info, isActiveProduct, onActiveChange }) {
    const lastUpdate = 'Last Price Update: ' + info.price_update;
    return (
        <div
            className={clsx("vzp_product col-sm-6 mb-3 mb-sm-0 py-2 rounded-1", {'active': isActiveProduct})}
            data-id={id}
        >
            <a className="card-rounded position-relative mb-5" href="#" onClick={(e) => onActiveChange(e,id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Click to apply on selected surface">
                <div
                    className="bgi-position-center bgi-no-repeat bgi-size-cover h-150px card-rounded rounded-1"
                    style={info.img ? {backgroundImage: 'url('+ info.img +')'} : {backgroundColor:info.color}}
                />
            </a>

            <div className="mt-2">
                <a href={info.link} target="_blank" className="text-gray-800 text-hover-primary fs-7 text-truncate-2lines">
                    {info.name}
                    {info.brand != undefined ? ' (' + info.brand + ')' : ''}
                </a>
                <div className="d-flex flex-stack pt-0">
                    {
                        info.price > 0.1 &&
                        <span className="fw-bold fs-7 text-gray-500 d-block lh-1" data-bs-toggle="tooltip" data-bs-placement="top" title={lastUpdate}>
                            <i className="ki-duotone ki-information-5 me-2">
                                 <span className="path1"></span>
                                 <span className="path2"></span>
                                 <span className="path3"></span>
                            </i>
                            {
                                [info.price, info.currency]
                            }
                        </span>
                    }
                    <a href={info.link} target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" title="View Product">
                        View
                        <i className="ki-duotone ki-exit-right-corner ms-1">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default function ProductList({products, fullModalState, deviceData, activeProduct, productsFilter, onActiveChange, onProductsPageChange, _onProductsFilterChange})  {

    const [showFilter, setShowFilter] = useState(false);
    const _onFilterClick = (e) => {
        e.preventDefault();
        setShowFilter(showFilter ? false : true);
    };

    const _onProductsFilterSubmit = (filterOptions) => {
        setShowFilter(false);
        _onProductsFilterChange(filterOptions);
    };

    const productList = useMemo(() => {
        let temp = [];
        let count = 0;
        Object.keys(products.list).forEach(key => {
            temp.push(products.list[key]);
        });
        const productList = temp.map((node, i) =>
            (<Product
                key={i}
                id={node.id}
                info={node.info}
                isActiveProduct={activeProduct == node.id ? true : false}
                onActiveChange={onActiveChange}
            />)
        )
        return productList;
    }, [products.list]);

    return <>
        <div
            className={clsx(
                "card card-flush",
                {'d-none': !fullModalState.products && !(deviceData.menuAxis == 'x' && !deviceData.horizontalBlock)}
            )}
            id="vz_product_list"
        >
            <ProductListHeader breadcrumbs={products.payload.breadcrumbs} showFilter={showFilter} _onFilterClick={_onFilterClick} />
            {
                showFilter ?
                    <ProductListFilter filter={productsFilter} _onProductsFilterChange={_onProductsFilterSubmit} />
                    :
                    <div className="card-body pt-7 scroll-y">
                        <Alert
                            title="Product application"
                            messages={["1. Select the walls", " 2. Click on the product image you want to apply"]}
                            theme="bg-light-primary"
                            hideDays={3}
                        />
                        <div className="row g-5 mb-5">
                            {productList}
                        </div>
                        { products.payload.pagination.last_page > 1 && <Pagination payload={products.payload.pagination} onPageChange={onProductsPageChange} /> }
                    </div>
            }
        </div>
    </>
}